<span>{{item.cartikelnummer}} - {{item.artbez1}}</span>
@if (item.artbez2) {
  <span> - {{item.artbez2}} </span>
}
@if (item.artbez3) {
  <span> - {{item.artbez3}} </span>
}
